// ═══════════════════════════════════════════════
//   AUDIO — BGM player + playlist
// ═══════════════════════════════════════════════

const {S, fmt} = window;

// ===== AUDIO =====
// ══════════════════════════════════════════
// AUDIO PLAYER + PLAYLIST
// ── To add a track: add one object to PLAYLIST below.
//    Upload the .mp3 to your assets/audio/ folder.
//    Format: { title, artist, src }
// ══════════════════════════════════════════
const PLAYLIST = [
    {
        title: 'Euphaia BGM (Loopable)',
        artist: 'Clowri — La Madriguera OST',
        src: 'assets/audio/_loopable__Euphaia_BGM_100BPM.mp3'
    },
    // Add more tracks below ↓
    // { title: 'Track Title', artist: 'Artist Name', src: 'filename.mp3' },
];

let audTrack = 0; // index of currently loaded track

const bgm = document.getElementById('bgm');
bgm.volume = S.audVol;

// Build the playlist UI
function buildPlaylist() {
    const el = document.getElementById('aud-playlist');
    if (!el) return;
    if (PLAYLIST.length <= 1) {
        el.style.display = 'none';
        return;
    }
    el.innerHTML = PLAYLIST.map((t, i) =>
        `<div class="aud-pl-item${i === audTrack ? ' on' : ''}" onclick="audLoadTrack(${i},true)">
      <span class="aud-pl-num">${i + 1}</span>
      <div class="aud-pl-info">
        <div class="aud-pl-title${i === audTrack ? ' on' : ''}">${t.title}</div>
        <div class="aud-pl-artist">${t.artist}</div>
      </div>
    </div>`
    ).join('');
}

function audLoadTrack(idx, play = false) {
    audTrack = ((idx % PLAYLIST.length) + PLAYLIST.length) % PLAYLIST.length;
    const t = PLAYLIST[audTrack];
    bgm.src = t.src;
    bgm.load();
    document.getElementById('aud-track-name').textContent = '♪ ' + t.title;
    document.getElementById('aud-artist-name').textContent = t.artist;
    document.getElementById('apfill').style.width = '0%';
    document.getElementById('acur').textContent = '0:00';
    document.getElementById('adur').textContent = '—';
    buildPlaylist();
    if (play || S.audPlaying) {
        bgm.play().catch(() => {
        });
        S.audPlaying = true;
        document.getElementById('abtn').textContent = '⏸';
        document.getElementById('adisc').classList.add('playing');
    }
    syncTbAudio();
}

function syncTbAudio() {
    const t = PLAYLIST[audTrack];
    const btn = document.getElementById('tb-aud-play');
    const track = document.getElementById('tb-aud-track');
    if (btn) btn.textContent = S.audPlaying ? '⏸' : '▶';
    if (track) track.textContent = '♪ ' + (t ? t.title : '—');
}

function audToggle() {
    if (S.audPlaying) {
        bgm.pause();
        document.getElementById('abtn').textContent = '▶';
        document.getElementById('adisc').classList.remove('playing');
    } else {
        bgm.play().catch(() => {
        });
        document.getElementById('abtn').textContent = '⏸';
        document.getElementById('adisc').classList.add('playing');
    }
    S.audPlaying = !S.audPlaying;
    syncTbAudio();
}

function audNext() {
    audLoadTrack(audTrack + 1, true);
}

function audPrev() {
    // If more than 3 seconds in, restart current; otherwise go to previous
    if (bgm.currentTime > 3) {
        bgm.currentTime = 0;
    } else {
        audLoadTrack(audTrack - 1, true);
    }
}

function setVol(v) {
    S.audVol = parseFloat(v);
    bgm.volume = S.audMuted ? 0 : S.audVol;
    document.getElementById('vol-pct').textContent = Math.round(v * 100) + '%';
    document.getElementById('vol-icon').textContent = v == 0 ? '🔇' : v < 0.4 ? '🔉' : '🔊';
}

function toggleMute() {
    S.audMuted = !S.audMuted;
    bgm.volume = S.audMuted ? 0 : S.audVol;
    document.getElementById('vol-icon').textContent = S.audMuted ? '🔇' : '🔊';
}

function seekAudio(e) {
    if (!bgm.duration) return;
    const r = document.getElementById('aud-prog').getBoundingClientRect();
    bgm.currentTime = ((e.clientX - r.left) / r.width) * bgm.duration;
}

// Advance to next track when current one ends
bgm.addEventListener('ended', () => {
    audLoadTrack(audTrack + 1, true);
});
bgm.addEventListener('timeupdate', () => {
    if (!bgm.duration) return;
    document.getElementById('apfill').style.width = (bgm.currentTime / bgm.duration * 100) + '%';
    document.getElementById('acur').textContent = fmt(bgm.currentTime);
    document.getElementById('adur').textContent = fmt(bgm.duration);
});
// Build the initial playlist UI on page load
buildPlaylist();
syncTbAudio();

window.audLoadTrack = audLoadTrack;
window.audToggle = audToggle;
window.audNext = audNext;
window.audPrev = audPrev;
window.setVol = setVol;
window.toggleMute = toggleMute;
window.seekAudio = seekAudio;
window.buildPlaylist = buildPlaylist;
window.syncTbAudio = syncTbAudio;
